export enum ReportType {
    ValuationReport = 1,
    PropertyDetailReport = 2,
    DraftStatementReport = 3
}